import { Entry } from 'contentful';

export function useActiveSlideConfig(slides: Entry[], currentIndex: number) {
  const slide = slides[currentIndex];
  if (!slide) return {};

  const { theme, mobileTheme, contentAlignment, mobileContentAlignment } = slide.fields;

  return {
    theme,
    mobileTheme,
    contentAlignment: contentAlignment ?? 'center',
    mobileContentAlignment: mobileContentAlignment ?? contentAlignment ?? 'center',
  };
}